export const defaultState = {
    itemId: undefined,
    selectedIndex: undefined,
    multiChoiceResponses: [],
    instructions: {},
    isFirstAttemptMade: false,
    isGreyedOut: false,
    isReadyForNextScreen: false,
    isResponsePlaying: false,
    classifiedResponses: undefined,
    questionCompleteness: [],
};

export const getIsQuestionsDataFetched = (state = defaultState) => state.isDataFetched;

export const getSelectedIndex = state => state.selectedIndex;

export const getIsFirstAttemptMade = state => state.isFirstAttemptMade;

export const getAudioInstructions = state => state.instructions;

export const getItemId = state => state.itemId;

export const getIsResponsePlaying = (state = defaultState) => state.isResponsePlaying;

export const getQuestionsIsReadyForNextScreen = state => state.isReadyForNextScreen;

export const getClassifiedResponses = state => state.classifiedResponses;

export const getMultiChoiceResponses = state => state.multiChoiceResponses;

export const getQuestionCompleteness = state => state.questionCompleteness;

export const getIsQuestionCompleted = (state, questionIndex) =>
    getQuestionCompleteness(state)[questionIndex];

export const getPlayingResponseIndex = state => state.playingResponseIndex;
